module.exports = __webpack_public_path__ + "static/media/ChargingStations.680648f9.xlsx";